<template>
  <fragment>
    <!-- Adquirir Novo Produto -->
    <div
      class="modal fade"
      id="adquirirNovoProduto"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5
              class="modal-title h4 d-flex align-items-center primary"
              id="modalCenterTitle"
            >
              <i class="material-icons pr-2 tertiary">arrow_forward_ios</i>
              Recomendados para Você
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div
                    class="col-md-4 col-lg-4 col-12 pt-4"
                    v-for="(produto, index) in produtosInativos"
                    :key="index"
                  >
                    <div
                      class="card product shadow text-center d-flex justify-content-center position-relative"
                    >
                      <i class="material-icons secondary add-produto">add</i>
                      <div class="card-body">
                        <span class="material-icons">category</span>
                        <p class="card-title">{{ produto.name }}</p>
                        <p class="card-text">{{ produto.desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <button
              type="button"
              class="btn btn-azul fit-content d-fle align-items-center d-flex justify-content-center"
            >
              <i class="material-icons pr-1">loyalty</i>
              <span>Alterar Meu Plano</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { api } from "@/services.js";
import produtosList from "../produtos.json";
export default {
  name: "ModalNovoProduto",
  data() {
    return {
      produtosLista: produtosList.produto,
      produtosAtivos: [],
      produtosInativos: [],
    };
  },
  methods: {
    getProductsActive() {
      api.get("/api/CdlBh/ListaProdutosAtivos").then((response) => {
        this.produtosAtivos = response.data;
        this.productsInative();
      });
    },
    productsInative() {
      const produtosAtivos = this.produtosAtivos;
      const produtosInativos = [];
      this.produtosLista.map(function (value) {
        if (produtosAtivos[value.id] == 0 && value.active == 0) {
          produtosInativos.push(value);
        }
      });
      this.produtosInativos = produtosInativos;
    },
  },
  created() {
    const dadosUsuario = this.$store.getters.getUsuario;
    if (dadosUsuario.carteira === "undefined") {
      this.getProductsActive();
    }
  },
};
</script>

<style lang="scss" scoped>
.modal {
  .modal-body {
    max-height: 485px;
    overflow: auto;
  }
  .modal-dialog {
    max-width: 900px;
    .card {
      cursor: pointer;
    }
  }
  .add-produto {
    font-size: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    margin: 0;
    padding: 0px;
  }
}
</style>
